module.exports = __webpack_public_path__ + "img/More.ed6d426a.svg";